import { Reducer } from './reducers'

interface State {
  activations: Reducer
}

export const isFetched = (state: State): boolean => state.activations.fetched
export const isAccountActivated = (state: State): boolean => state.activations.isAccountActivated
